import React, { useEffect, useState } from "react";


import message from 'antd/lib/message';
import Popconfirm from 'antd/lib/popconfirm';
import Spin from 'antd/lib/spin';
import Pagination from 'antd/lib/pagination';
import { Table } from 'antd/lib/table';
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import AppService from './../../../../../service/app_service'
import AuthenticationService from './../../../../../service/authentication_service'
import UrlService from './../../../../../service/url_service'
import TopBarComponent from './../../../component/topbar_component'
import ModalComponent from './../../../component/modal_component'
import SockJsClient from 'react-stomp';
import { PaystackButton } from "react-paystack"

var interval = null;
var downloadTimer = null;
const GiveawayPage = (props) => {

    const [loading, setLoading] = useState(false);
    const [transactions, setTransactions] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [pageNumber, setPageNumber] = useState(1);
    const [totalTransactionCount, setTotalTransactionCount] = useState(0);

    const [identifier, setIdentifier] = useState(null);
    const [identifierName, setIdentifierName] = useState(null);
    const [name, setName] = useState(null);
    const [addCandidate, setAddCandidate] = useState(false);
    const [addOptionItem, setAddOptionItem] = useState(false);

    


    useEffect(() => {
        getTransactions(pageNumber);
        //eslint-disable-next-line

    }, []);

    const getTransactions = async (pageNumber) => {
        setLoading(true);
        AppService.getEvotingDetail(pageSize, pageNumber, props.match.params.uid, "xoxox").then(rec => {
            setLoading(false)
            if (rec.code != "200") {
                message.error(rec.message)
            } else {
                setTransactions(rec.data);
                if (rec && rec.list) {
                    //setTotalTransactionCount(rec.list.length);
                }
            }
        })

    }


    const toggleClosingStatus = async () => {
        setLoading(true);
        AppService.toggleClosingStatus(props.match.params.uid).then(rec => {
            setLoading(false)
            if (rec.code != "200") {
                message.error(rec.message)
            } else {
                setName(null);
                getTransactions(pageNumber);
            }
        })
    }

    const changePage = (val) => {
        setPageNumber(val)
        getTransactions(val);
    }


    const addParticipant = () => {
        let data = {};
        data.identifier = identifier;
        data.name = identifierName;
        data.evotingId = props.match.params.uid;
        addParticipantEndpoint(data);
        setLoading(true);
    };

    const addParticipantEndpoint = async (data) => {
        setLoading(true);
        AppService.addParticipantEndpoint(data).then(rec => {
            setLoading(false)
            if (rec.code != "200") {
                message.error(rec.message)
            } else {
                setIdentifier('');
                setIdentifierName('');
                getTransactions(pageNumber);
            }
        })
    }

    const deleteParticipantEndpoint = async (data) => {
        setLoading(true);
        AppService.deleteParticipantEndpoint(data).then(rec => {
            setLoading(false)
            if (rec.code) {
                message.error(rec.message)
            } else {
                getTransactions(pageNumber);
            }
        })
    }

    const addOption = () => {
        let data = {};
        data.name = name;
        data.evotingId = props.match.params.uid;
        addOptionEndpoint(data);
        setLoading(true);
    };

    const addOptionEndpoint = async (data) => {
        setLoading(true);
        AppService.addOptionEndpoint(data).then(rec => {
            setLoading(false)
            if (rec.code != "200") {
                message.error(rec.message)
            } else {
                setName(null);
                getTransactions(pageNumber);
            }
        })
    }

    const deleteOptionEndpoint = async (data) => {
        setLoading(true);
        AppService.deleteOptionEndpoint(data).then(rec => {
            setLoading(false)
            if (rec.code) {
                message.error(rec.message)
            } else {
                getTransactions(pageNumber);
            }
        })
    }

    const notifyOptionEndpoint = async (data) => {
        setLoading(true);
        AppService.notifyParticipantEndpoint(data).then(rec => {
            setLoading(false)
            if (rec.code != "200") {
                message.error(rec.message)
            } else {
                message.success("Notified successfully")
                getTransactions(pageNumber);
            }
        })
    }

    
    const handleChange = (e) => {
        if (e.target.name === 'identifier') {
            setIdentifier(e.target.value);
        } else if (e.target.name === 'name') {
            setName(e.target.value);
        } else if (e.target.name === 'identifierName') {
            setIdentifierName(e.target.value);
        }
        

    }

    const getMyChoice = (trans, choice) => {
        let myChoice = "";
        if(trans && trans.options && trans.options.length > 0) {
            for (let i = 0; i < trans.options.length; i++) {
                if ((i+1) == choice) {
                    myChoice = trans.options[i].name;
                }
            }
        }
        
        return myChoice;
    }


    return (
        <div id="main-wrapper" className="admin-dashboard-demos" style={{ background: '#e0e8f3', minHeight: '700px' }} >
            <TopBarComponent />
            <Spin spinning={loading}>
            <div className="page-content">
                <div className="container">
                    <div className="card content-area">
                        <div className="card-innr">
                            <div className="card-head" style={{ width: '100%' }}>
                                <h4 className="card-title"><em className="text-primary ti ti-reload" style={{ paddingLeft: '15px' }} onClick={() => getTransactions(pageNumber)} /></h4>
                                <div style={{ float: 'right', margin: '10px 0px', width: 'auto' }}>
                                    <Link to="/evoting" className="btn btn-sm btn-auto btn-primary d-sm-block d-none"><em className="fas fa-arrow-left mr-3" />Back</Link>
                                    <Link to="/evoting" className="btn btn-icon btn-sm btn-primary d-sm-none"><em className="fas fa-arrow-left" /></Link>
                                </div>
                            </div>

                            <div className="content-area card" style={{ width: '100%' }}>
                                <div className="card-innr">
                                    <div className="card-head d-flex justify-content-between align-items-center">
                                        <h4 className="card-title mb-0"></h4>
                                        {/* <a className="btn btn-sm btn-outline btn-light" onClick={() => setShowGiveawayModal(true)} style={{float: 'right'}}><em className="text-primary ti ti-files" /><span>Generate Giveaway</span></a>
                                         */}
                                    </div>
                                    <div className="card-head">
                                        <h4 className="card-title">{transactions && transactions.question}</h4>
                                        <h6>Status : {(transactions && transactions.closedStatus > 0) ? "CLOSED" : "OPEN"}</h6>
                                    </div>
                                    <a className={"btn btn-auto btn-xs btn-default"} style={{ marginLeft: '5px' }} onClick={() => { navigator.clipboard.writeText("https://unifiedorbit.com/vote/interest/"+props.match.params.uid); message.info(' Copied to Clipboard') }} data-clipboard-text={"https://unifiedorbit.com/vote/interest/"+props.match.params.uid}>Copy Interest Link</a>
                                    <a className={"btn btn-auto btn-xs btn-default"} style={{ marginLeft: '5px' }} onClick={() => { navigator.clipboard.writeText("https://unifiedorbit.com/vote/poll/"+props.match.params.uid); message.info(' Copied to Clipboard') }} data-clipboard-text={"https://unifiedorbit.com/vote/poll/"+props.match.params.uid}>Copy Poll Link</a>
                                    <a className={"btn btn-auto btn-xs btn-default"} style={{ marginLeft: '5px' }} onClick={() => { navigator.clipboard.writeText("https://unifiedorbit.com/vote/result/"+props.match.params.uid); message.info(' Copied to Clipboard') }} data-clipboard-text={"https://unifiedorbit.com/vote/result/"+props.match.params.uid}>Copy Poll Result Link</a>


                                    {transactions && <a className={"btn btn-auto btn-xs btn-primary"} style={{ marginLeft: '5px' }} onClick={() => toggleClosingStatus()} >{transactions.closedStatus > 0 ? "Open Voting" : "Close Voting"}</a>}


                                    
                                </div>
                            </div>

                            <div className="row" >
                                
                                <div className="col-md-12">
                                    <h4>Voting Participants</h4>
                                    <table className="data-table dt-init user-tnx dataTable no-footer bordered" id="" role="grid" aria-describedby="DataTables_Table_0_info">
                                        <thead>
                                            <tr className="data-item data-head" role="row">
                                                <th className="data-col dt-token sorting_disabled" rowSpan={1} colSpan={1}>Voters Name</th>
                                                <th className="data-col dt-tnxno sorting_disabled" rowSpan={1} colSpan={1}>Voters Email/Phone</th>
                                                <th className="data-col dt-usd-amount sorting_disabled" rowSpan={1} colSpan={1}>Choice</th>
                                                
                                                <th>Delete</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {transactions && transactions.candidates && transactions.candidates.length > 0 && transactions.candidates.map((item, i) => {
                                                return <tr className="data-item odd" role="row" key={i} >
                                                    <td className="data-col dt-token">{item.name}</td>
                                                    <td className="data-col dt-token">{item.identifier}</td>
                                                    <td className="data-col dt-token">{getMyChoice(transactions, item.choice)}</td>
                                                    <td>
                                                    {<Popconfirm
                                                        title="Are you sure to submit this action?"
                                                        onConfirm={() => deleteParticipantEndpoint(item)}
                                                        okText="Yes"
                                                        cancelText="No"
                                                    >
                                                        <button type="submit" disabled={loading} name="" className="btn btn-danger " style={{minWidth: "0px"}}>Delete</button>
                                                    </Popconfirm>}
                                                    {<Popconfirm
                                                        title="Are you sure to submit this action?"
                                                        onConfirm={() => notifyOptionEndpoint(item)}
                                                        okText="Yes"
                                                        cancelText="No"
                                                    >
                                                        <button type="submit" disabled={loading} name="submit" className="btn btn-success " style={{minWidth: "0px"}}>Notify</button>
                                                    </Popconfirm>}
                                                    </td>
                                                </tr>
                                            })}

                                        </tbody>
                                    </table>
                                </div>
                                <div className="col-md-12" style={{marginTop: '10px'}}></div>
                                <div className="col-md-12" >
                                    <h4> Voting Options</h4>
                                    <table className="data-table dt-init user-tnx dataTable no-footer" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                                        <thead>
                                            <tr className="data-item data-head" role="row">
                                                <th className="data-col dt-tnxno sorting_disabled" rowSpan={1} colSpan={1}>S/N</th>
                                                <th className="data-col dt-token sorting_disabled" rowSpan={1} colSpan={1}>Name</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {transactions && transactions.options && transactions.options.length > 0 && transactions.options.map((item, i) => {
                                                return <tr className="data-item odd" role="row" key={i} >
                                                    <td className="data-col dt-token">{i + 1}</td>
                                                    <td className="data-col dt-token">{item.name}</td>
                                                    <td>
                                                    {<Popconfirm
                                                        title="Are you sure to submit this action?"
                                                        onConfirm={() => deleteOptionEndpoint(item)}
                                                        okText="Yes"
                                                        cancelText="No"
                                                    >
                                                        <button type="submit" disabled={loading} name="submit" className="btn btn-danger " style={{minWidth: "0px"}}>Delete</button>
                                                    </Popconfirm>}
                                                    
                                                    </td>
                                                </tr>
                                            })}

                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div className="row " style={{marginTop: '50px'}} >
                                        <div className="col-md-6">
                                            <div className="row " >
                                                <div className="col-md-12">
                                                    <h5>Add Voting Participant</h5>
                                                    <button type="submit" onClick={() => setAddCandidate(!addCandidate)} name="submit" className="btn btn-primary">{addCandidate ? 'Cancel' : 'Add'}</button>
                                                </div>
                                                {addCandidate && <div>
                                                    <div className="col-md-12">
                                                        <div className="input-item input-with-label">
                                                            <label className="input-item-label">Name </label>
                                                            <input type="text" name="identifierName" value={identifierName} className="input-bordered" placeholder="Voters Name" onChange={handleChange} />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="input-item input-with-label">
                                                            <label className="input-item-label">Phone Number/ Email </label>
                                                            <input type="text" name="identifier" value={identifier} className="input-bordered" placeholder="Phone or Email" onChange={handleChange} />
                                                        </div>
                                                    </div>


                                                    <div className="col-md-12">
                                                        {<Popconfirm
                                                            title="Are you sure to submit this action?"
                                                            onConfirm={addParticipant}
                                                            okText="Yes"
                                                            cancelText="No"
                                                        >
                                                            <button type="submit" disabled={loading} name="submit" className="btn btn-success btn-block">Add</button>
                                                        </Popconfirm>}
                                                    </div>
                                                </div>}

                                            </div>
                                        </div>


                                        <div className="col-md-6">
                                            <div className="row " >
                                                <div className="col-md-12">
                                                    <h5>Add Voting option</h5>
                                                    <button type="submit" onClick={() => setAddOptionItem(!addOptionItem)} name="submit" className="btn btn-primary">{addOptionItem ? 'Cancel' : 'Add'}</button>
                                                </div>
                                                {addOptionItem && <div>
                                                    <div className="col-md-12">
                                                        <div className="input-item input-with-label">
                                                            <label className="input-item-label">Name  </label>
                                                            <input type="text" name="name" value={name} className="input-bordered" placeholder="Name" onChange={handleChange} />
                                                        </div>
                                                    </div>

                                                    <div className="col-md-12">
                                                        {<Popconfirm
                                                            title="Are you sure to submit this action?"
                                                            onConfirm={addOption}
                                                            okText="Yes"
                                                            cancelText="No"
                                                        >
                                                            <button type="submit" disabled={loading} name="submit" className="btn btn-success btn-block">Add Option</button>
                                                        </Popconfirm>}
                                                    </div>
                                                </div>}
                                                

                                            </div>
                                        </div>

                                    </div>



                        </div>
                        {/* .card-innr */}
                    </div>
                    {/* .card */}
                </div>
                {/* .container */}
            </div>
            </Spin>



        </div>
    );

}

export default withRouter(GiveawayPage);
